<template>
  <div>
    <div v-if="label" class="text-xs text-gray-400 whitespace-nowrap">
      {{ label }}
    </div>
    <slot>{{ value }}</slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FieldDisplay",
  props: {
    label: {
      type: String,
      required: false,
    },
    value: {
      type: [String, Number],
      required: false,
    },
  },
});
</script>
